import {gql} from '@apollo/client';

export const CreateNPC = gql`
    mutation CreateNPC($adventureId: Int!, $npcLevel: Int!, $npcName: String!, $classId: Int, $subclassId: Int, $raceId: Int, $subraceId: Int) {
        createNPC(adventureId: $adventureId, npcLevel: $npcLevel, npcName: $npcName, classId: $classId, subclassId: $subclassId, raceId: $raceId, subraceId: $subraceId) {
            npcId
        }
    }
`

export const UpdateNPC = gql`
    mutation UpdateNPC($npcId: Int!, $adventureId: Int!, $npcLevel: Int!, $npcName: String!, $classId: Int, $subclassId: Int, $raceId: Int, $subraceId: Int) {
        updateNPC(npcId: $npcId, adventureId: $adventureId, npcLevel: $npcLevel, npcName: $npcName, classId: $classId, subclassId: $subclassId, raceId: $raceId, subraceId: $subraceId) {
            npcId
        }
    }
`

export const DeleteNPC = gql`
    mutation DeleteNPC($npcId: Int!) {
        deleteNPC(npcId: $npcId)
    }
`